import React, { useId, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useTeamLocale } from "./TeamLocaleContext";

const DealMapStageHelp = ({ stages, colors }) => {
  const { t } = useTeamLocale();
  const [open, setOpen] = useState(false);
  const dialogId = useId();
  const close = () => setOpen(false);

  return (
    <div className="team-deal-map-stage-help">
      <button
        type="button"
        className="btn-ghost team-deal-map-stage-help-trigger"
        aria-haspopup="dialog"
        aria-controls={open ? dialogId : undefined}
        onClick={() => setOpen(true)}
      >
        <InfoOutlinedIcon fontSize="small" aria-hidden="true" />
        {t("dealMap.stageHelp")}
      </button>

      <Dialog
        id={dialogId}
        open={open}
        onClose={close}
        fullWidth
        maxWidth="sm"
        scroll="paper"
        disableScrollLock={false}
        aria-labelledby={`${dialogId}-title`}
        aria-describedby={`${dialogId}-intro`}
        className="team-deal-map-stage-help-modal"
        PaperProps={{ className: "team-deal-map-stage-help-dialog" }}
      >
        <DialogTitle id={`${dialogId}-title`} className="team-deal-map-stage-help-title">
          <span>{t("dealMap.stageHelpTitle")}</span>
          <IconButton onClick={close} aria-label={t("common.close")}>
            <CloseRoundedIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="team-deal-map-stage-help-content">
          <p id={`${dialogId}-intro`} className="team-deal-map-stage-help-intro">
            {t("dealMap.stageHelpIntro")}
          </p>
          <ul className="team-deal-map-stage-help-items">
            {stages.map((stage) => (
              <li className="team-deal-map-stage-help-item" key={stage}>
                <i style={{ background: colors[stage] }} aria-hidden="true" />
                <div>
                  <h3>{stage}</h3>
                  <p>{t(`dealMap.stageDescription.${stage.toLowerCase()}`)}</p>
                </div>
              </li>
            ))}
          </ul>
        </DialogContent>
        <DialogActions className="team-deal-map-stage-help-footer">
          <button type="button" className="btn-primary" onClick={close}>
            {t("common.close")}
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DealMapStageHelp;
